import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const skip = ["/auth/refresh", "/auth/login", "/auth/register"].some((p) => cfg.url?.includes(p));
    if (error.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch {
        /* fall through */
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan. Coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fileUrl = (u) => (u ? (u.startsWith("/api/") ? `${BASE}${u}` : u) : undefined);

export async function downloadFile(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
export const privateFileUrl = (path) => `${API}/private-files/${path}`;
export const rupiah = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");
export const formatNig = (nig) => (nig ? `${nig.slice(0, 2)} · ${nig.slice(2, 4)} · ${nig.slice(4, 5)} · ${nig.slice(5)}` : "—");
export const fmtDate = (d, opts = { day: "numeric", month: "long", year: "numeric" }) =>
  d ? new Date(d.length === 10 ? `${d}T00:00:00` : d).toLocaleDateString("id-ID", opts) : "";

const DAYS = { minggu: 0, senin: 1, selasa: 2, rabu: 3, kamis: 4, jumat: 5, sabtu: 6 };
export function nextOccurrence(schedule) {
  const day = DAYS[(schedule.day || "").split(" ")[0].toLowerCase()] ?? 0;
  const [h, m] = (schedule.time || "09:00").split(":").map(Number);
  const now = new Date();
  const t = new Date(now);
  t.setDate(now.getDate() + ((day - now.getDay() + 7) % 7));
  t.setHours(h, m, 0, 0);
  if (t <= now) t.setDate(t.getDate() + 7);
  return t;
}
